import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/api";

export default function Login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const onGoogle = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <div className="card-soft p-8 text-center">
        <img src={BRAND.mascot} alt="Zi Zi" className="w-20 h-20 rounded-full mx-auto ring-4 ring-pink-100" />
        <h1 className="font-display text-3xl font-bold mt-4">Welcome to Zi Zi's World</h1>
        <p className="text-slate-600 mt-2">Sign in with Google to save your ID cards, earn member points, and start fundraisers.</p>
        <button data-testid="google-login-btn" onClick={onGoogle} className="btn-pink w-full mt-6">Continue with Google</button>
        <Link to="/" className="block mt-4 text-sm text-slate-500">← Back home</Link>
      </div>
    </div>
  );
}
